<template>
  <div :class="['blur-background', sidebarLeft ? 'sidebar-left': 'sidebar-mobile']" @click="onClickHandle">

  </div>
</template>
<script>
  import Vue from "vue";
  import {mapActions, mapGetters} from "vuex";

  export default Vue.extend({
    props: ["sidebarLeft"],
    methods: {
      onClickHandle(){
        if (this.$props.sidebarLeft) this.changeVision()
        else this.toggleMobileMenu()
      },
      ...mapActions([
        'changeVision', 'toggleMobileMenu'
      ])
    },
  })
</script>
<style lang="scss" scoped>;
  .blur-background {
    width: calc(100% - 200px);
    position: absolute;
    right: 0;
    top: 0;
    backdrop-filter: saturate(180%) blur(3px);
    height: 100%;
    min-height: 100vh;
    z-index: 10;
    @media(max-width: 950px) {
      width: 100%;
    }
    &.sidebar-left {
      @media(max-width:450px) {
        display: none;
      }
    }
    &.sidebar-mobile {
      left: 0;
      width: 100%;
    }
  }
</style>